import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export function RatingBar({ activeColor, bars, rating, barWidth = 6, barGap = undefined }) {
  const hasCustomBarGap = typeof barGap === 'number';

  return (
    <span
      className={hasCustomBarGap ? 'd-flex align-items-end' : 'd-flex align-items-end gap-0_25'}
      style={hasCustomBarGap ? { gap: `${barGap}px` } : undefined}
    >
      {bars.map(({ id, height }) => {
        const isActive = id <= rating;

        return (
          <span
            key={id}
            className={classNames('bg-cool-gray-70', { [`bg-${activeColor}`]: isActive })}
            style={{ width: barWidth, height: `${height}px` }}
          />
        );
      })}
    </span>
  );
}

RatingBar.propTypes = {
  activeColor: PropTypes.string.isRequired,
  bars: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, height: PropTypes.number })).isRequired,
  rating: PropTypes.number.isRequired,
  barWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  barGap: PropTypes.number,
};
